/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import type { FunctionComponent } from 'react'
import style from './Message.module.sass'

type MessageProps = {
	icon: JSX.Element
	text: JSX.Element | string
	onClick?: React.MouseEventHandler<HTMLDivElement>
}

export const Message: FunctionComponent<MessageProps> = ({ icon, text, onClick }) => {
	return (
		<div className={style.root} onClick={onClick}>
			<div className={style.icon}>{icon}</div>
			<div className={style.text}>{text}</div>
		</div>
	)
}
